import { render, staticRenderFns } from "./ProductSearchModal.vue?vue&type=template&id=4f12de96&scoped=true&"
import script from "./ProductSearchModal.vue?vue&type=script&lang=js&"
export * from "./ProductSearchModal.vue?vue&type=script&lang=js&"
import style0 from "./ProductSearchModal.vue?vue&type=style&index=0&id=4f12de96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f12de96",
  null
  
)

/* custom blocks */
import block0 from "./ProductSearchModal.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCard,VCardTitle,VChip,VContainer,VDialog,VForm,VImg,VListItemAvatar,VListItemContent,VListItemSubtitle,VListItemTitle,VProgressCircular})
